import { render, staticRenderFns } from "./injectionProduction.vue?vue&type=template&id=212b17fa&scoped=true"
import script from "./injectionProduction.vue?vue&type=script&lang=js"
export * from "./injectionProduction.vue?vue&type=script&lang=js"
import style0 from "./injectionProduction.vue?vue&type=style&index=0&id=212b17fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b17fa",
  null
  
)

export default component.exports